export const sync = {
  name: "sync" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12.015 4.786a7.218 7.218 0 0 0-7.219 7.219.9.9 0 1 1-1.8 0 9.018 9.018 0 0 1 15.189-6.577v-1.48a.9.9 0 1 1 1.8 0V8.92h-4.973a.9.9 0 0 1 0-1.8h2.318a7.199 7.199 0 0 0-5.315-2.334Zm8.118 6.319a.9.9 0 0 1 .9.9A9.018 9.018 0 0 1 5.83 18.568v1.469a.9.9 0 1 1-1.8 0v-4.973h4.973a.9.9 0 1 1 0 1.8H6.677a7.218 7.218 0 0 0 12.556-4.86.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["sync"],
  category: "action" as const,
};
